import { useIsClientPortalAdminUser } from '../useIsClientPortalAdminUser';
import { useIsClientPortalUser } from '../useIsClientPortalUser';
import { useIsPassengerPortalUser } from '../useIsPassengerPortalUser';

/**
 * Hook to determine if a user is a passenger portal user but
 * not a client portal user or admin
 */
export const useIsPassengerPortalOnlyUser = (): boolean => {
  const isPassengerPortalUser = useIsPassengerPortalUser();
  const isClientPortalUser = useIsClientPortalUser();
  const isClientAdminUser = useIsClientPortalAdminUser();
  return isPassengerPortalUser && !isClientPortalUser && !isClientAdminUser;
};
